import { Controller } from "@hotwired/stimulus"

// Native Rails 8 replacement for the cocoon gem's dynamic add/remove
// behavior. Reusable at any nesting level (missions inside an
// assignment, rides inside a mission) -- each level gets its own
// controller instance scoped to its own <template>/list/buttons, which
// is what keeps a "remove" click from ever being ambiguous about which
// level it applies to.
//
// Expects, within the controller's element:
//   - a [data-nested-form-target="list"] container holding the
//     existing (and later, newly added) rows
//   - a <template data-nested-form-target="template"> containing one
//     blank row, built server-side with child_index: "NEW_RECORD"
//   - an "add" link/button with data-action="nested-form#add"
// Each row (rendered by the same partial used inside the template)
// needs:
//   - the .nested-fields class, so remove() can find its own row via
//     closest(".nested-fields") regardless of where inside the row the
//     remove link/button lives
//   - data-persisted="true"/"false" (f.object.persisted?) on that same
//     row element
//   - a hidden _destroy field (f.hidden_field :_destroy) so remove()
//     can mark a persisted record for destruction
//   - a "remove" link/button with data-action="nested-form#remove"
export default class extends Controller {
  static targets = ["list", "template"]

  add(event) {
    event.preventDefault()

    const uid = new Date().getTime()
    const html = this.templateTarget.innerHTML.replaceAll("NEW_RECORD", uid)

    const wrapper = document.createElement("template")
    wrapper.innerHTML = html.trim()
    const row = wrapper.content.firstElementChild

    this.listTarget.appendChild(row)
    this.dispatch("added", { detail: { row } })
  }

  remove(event) {
    event.preventDefault()

    const row = event.target.closest(".nested-fields")
    if (!row) return

    if (row.dataset.persisted === "true") {
      const destroyField = row.querySelector("input[type=hidden][name*='_destroy']")
      if (destroyField) destroyField.value = "1"
      row.style.display = "none"
    } else {
      row.remove()
    }

    this.dispatch("removed", { detail: { row } })
  }
}
